import type { Locale } from '../../i18n/locales'
import type { Technique } from './types'

/** CJK script label for the active locale (falls back to Japanese). */
export function techniqueScriptName(technique: Technique, locale: Locale): string {
  if (locale === 'zh-Hant' && technique.nameZh) return technique.nameZh
  return technique.nameJa
}

/** Bilingual technique label: script name + English/romanized name. */
export function techniqueDisplayName(technique: Technique, locale: Locale): string {
  return `${techniqueScriptName(technique, locale)} (${technique.name})`
}

export function techniqueScriptLang(
  technique: Technique,
  locale: Locale,
): 'ja' | 'zh-Hant' {
  if (locale === 'zh-Hant' && technique.nameZh) return 'zh-Hant'
  return 'ja'
}
